import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 60 + theme.spacing[4] + rt.insets.bottom,
  },
  calendarPlaceholder: {
    padding: theme.spacing[6],
    borderRadius: theme.borderRadius.m,
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundL1,
  },
  guestSectionPlaceholder: {
    padding: theme.spacing[8],
    borderRadius: theme.borderRadius.m,
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundL1,
  },
}));
